import script from "./NewPasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewPasswordView.vue?vue&type=script&setup=true&lang=js"

import "./NewPasswordView.vue?vue&type=style&index=0&id=707120e3&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-707120e3"]])

export default __exports__